import { FETCH_APPOINTMENTS_REQUEST, FETCH_APPOINTMENTS_SUCCESS, FETCH_APPOINTMENTS_FAILURE , RESET_UPCOMING_APPOINTMENTS } from "./appointmentTypes";
import { apiService } from "../../utils/apiRequest";
import store from "../store.js"; 


export const resetUpcomingAppointments = () => ({
  type: RESET_UPCOMING_APPOINTMENTS,
});

// Action to indicate that appointment fetching has started
export const fetchAppointmentsRequest = () => ({
  type: FETCH_APPOINTMENTS_REQUEST,
});

// Action to handle successful fetching of appointments
export const fetchAppointmentsSuccess = (appointments) => ({
  type: FETCH_APPOINTMENTS_SUCCESS,
  payload: appointments,
});

// Action to handle failure in fetching appointments
export const fetchAppointmentsFailure = (error) => ({
  type: FETCH_APPOINTMENTS_FAILURE,
  payload: error,
});

// Async action to fetch appointments from the API
export const fetchAppointments = (franchiseProfile , page , selected_date  , filterdata ) => async (dispatch) => {
  dispatch(fetchAppointmentsRequest()); // Dispatch request action before API call

  try {
    // Get the current state to retrieve the access token
    const state = store.getState();
    const accessToken = state.auth.accessToken; 
    const upcomingappointment = process.env.REACT_APP_API_URL + 'getUpcomingAppointments';

    // Ensure access token is available before making the request
    if (!accessToken) {
      throw new Error("Access token is missing. Please log in again.");
    }

    // Make the API request with authentication headers
    const response = await apiService(upcomingappointment, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,  
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tutor_id: franchiseProfile.tutor_id,  
        franchise_id: franchiseProfile.franchise_id,
        page_number : page ,
        page_size: 25,
        selected_date: selected_date,
        appointment_type: String(filterdata?.appointment_type ?? ''),
        session_type: filterdata?.session_type,
        student_id: filterdata?.student_id,
        job_id: filterdata?.job_id,
        subject: filterdata?.subject_id,
      }),
    });
    dispatch(fetchAppointmentsSuccess(response)); // Dispatch success action with fetched data
  } catch (error) {
    console.error("Error fetching appointments:", error);
    dispatch(fetchAppointmentsFailure(error.message)); // Dispatch failure action in case of error
  }
};
